import { useAccount } from 'wagmi'

import { FEATURE } from 'constants/feature'
import { useVestingContextV2 } from 'context/vesting-context-provider-v2'
import { usePermission } from 'hooks/use-permission'

/** Admin role decides whether the whitelist section is visible at all. */
export const useCanManageWhitelist = (): boolean => {
  const { canCRUD } = usePermission()
  return canCRUD(FEATURE.VESTING)
}

/**
 * On-chain writes need a connected wallet that owns or manages the contract.
 * When Safe multisig lands, add its grant here — call sites stay unchanged.
 */
export const useCanWriteWhitelist = (): boolean => {
  const { address } = useAccount()
  const { isOwner, isContractManager } = useVestingContextV2()

  return Boolean(address) && (isOwner || isContractManager)
}
